import React, { useEffect, useState } from "react";
import { ReactComponent as AccordianArrow } from "../assets/svg/accordian-arrow.svg";
import Header from "../components/Header";
import useLocale from "../locales";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import { apiRoutes } from "../api/apiRoutes";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "../redux/loading/loadingSlice";
import {
  parseRichTextToHTML,
  parseLexicalToHTML,
  parseRichTextWithFormatting,
} from "../utiles/richTextParser";

const Faq = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();
  const [openItems, setOpenItems] = useState({});
  const { textData } = useLocale();
  const { faqsheader } = textData;
  const [faqs, setFaqs] = useState([]);
  const [error, setError] = useState(null);

  const toggleItem = (index) => {
    setOpenItems((prev) => ({
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    async function getAllFaq() {
      try {
        dispatch(setLoading(true));
        const response = await axiosInstance.get(
          `${apiRoutes.GET_ALL_FAQ}?lang=${i18n.language}`
        );
        setFaqs(response?.data?.data);
        dispatch(setLoading(false));
      } catch (error) {
        setError(error.message);
      } finally {
        dispatch(setLoading(false));
      }
    }
    getAllFaq();
  }, []);

  return (
    <>
      <Helmet>
        <title>Customer FAQs | Clear Solutions to Your Top Questions</title>
        <meta
          name="description"
          content="Find quick, clear answers to common questions in our FAQ section. Get support, understand features, and resolve queries easily with our user-friendly guide."
        />

        {/* Canonical */}
        <link rel="canonical" href="https://growlifefund.com/faq" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Customer FAQs | Clear Solutions to Your Top Questions"
        />
        <meta
          property="og:description"
          content="Find quick, clear answers to common questions in our FAQ section. Get support, understand features, and resolve queries easily with our user-friendly guide."
        />
        <meta property="og:url" content="https://growlifefund.com/faq" />
        <meta property="og:site_name" content="growlifefund" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="FAQ of Free Finance Calculator"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>
      <Header />
      <div className=" max-w-[1280px]  md:px-0 lg:px-[20px] xl:px-[30px] px-0 mx-3 sm:mx-5 xl:mx-auto ">
        {/* Breadcrumb */}
        <div className="mt-6 pb-5">
          <div className="flex  item-center ">
            <span
              className="text-blue-shade text-sm sm:text-base md:text-lg xl:text-xl font-medium  cursor-pointer"
              onClick={() => navigate("/")}
            >
              {faqsheader.home}
            </span>
            <span className="mx-2 text-gray-font ">{">"}</span>
            <span className="text-gray-font text-sm sm:text-base md:text-lg xl:text-xl font-medium">
              {faqsheader.faqs}
            </span>
          </div>
        </div>

        <div className="border border-solid border-gray-light rounded-[20px] p-4 sm:p-[30px] xl:p-10">
          <div className="text-center">
            <h1 className="text-lg sm:text-xl lg:text-[22px] xl:text-[26px] font-bold text-black">
              {faqsheader.title}{" "}
              <span className="text-primary">{faqsheader.subtitle}</span>
            </h1>
            <p className="text-gray-font max-w-[904px] mx-auto font-normal text-sm sm:text-[15px] lg:text-base pt-4">
              {faqsheader.description}
            </p>
          </div>

          <div className="">
            {faqs?.map((item, index) => (
              <div
                key={index}
                className="bg-light-gray-2 rounded-[4px] shadow-sm overflow-hidden mt-6 p-4 sm:p-5 lg:p-6 xl:p-[30px] border-b-[1px] border-solid border-primary"
              >
                <button
                  onClick={() => toggleItem(index)}
                  className="w-full  text-left flex gap-[10px] justify-between items-center hover:bg-gray-50 transition-colors duration-200 focus:outline-none focus:bg-gray-50"
                >
                  <h2 className="font-medium text-black text-[15px] sm:text-lg">
                    {item?.question}
                  </h2>
                  {openItems[index] ? (
                    <AccordianArrow className="max-w-3 sm:max-w-4 w-full" />
                  ) : (
                    <AccordianArrow className="rotate-180 max-w-3 sm:max-w-4  w-full" />
                  )}
                </button>

                {openItems[index] && (
                  <>
                    <div className="border-b-[1px] border-solid border-gray-light pt-5 sm:pt-6 xl:pt-[30px]"></div>
                    <div className="pt-5 sm:pt-6 xl:pt-[30px]">
                      <div
                        className="text-gray-font font-normal text-sm sm:text-base leading-relaxed prose prose-sm max-w-none [&_a]:text-blue-500 [&_a]:hover:text-blue-700 [&_a]:underline [&_a]:font-medium [&_p]:mb-3 [&_strong]:font-bold [&_em]:italic [&_u]:underline [&_s]:line-through [&_br]:block [&_br]:h-2 [&_h2]:font-bold [&_h2]:text-lg [&_h2]:mb-2 [&_h2]:mt-4 [&_a_s]:line-through-0 [&_a_s]:no-underline"
                        dangerouslySetInnerHTML={{
                          __html:
                            parseRichTextWithFormatting(item?.answer) ||
                            parseLexicalToHTML(item?.answer) ||
                            item?.answer,
                        }}
                      />
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Faq;
